import React, { useEffect, useMemo, useState } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Assignment, Delete, PictureAsPdf, Search, Visibility } from '@material-ui/icons';
import PdfModal from 'components/Tvendo/Common/PdfModal';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { WithApp } from 'contexts/appContext';
import { wsFindBy, wsRemove } from 'services/WService';
import { Box, InputAdornment, TextField, Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { currency } from 'hooks/Pipe';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';
import moment from 'moment';
import GridItem from 'components/Grid/GridItem';
import Badge from 'components/Badge/Badge';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 150 },
  { Header: 'Id', accessor: 'id', width: 80 },
  { Header: 'Procesado', accessor: 'process', excelEnabled: false, width: 120 },
  { Header: 'Zona', accessor: 'zone', width: 120 },
  { Header: 'Tipo', accessor: 'type', width: 100 },
  { Header: 'Usuario', accessor: 'user', width: 200 },
  { Header: 'Fecha Creación', accessor: 'created_at', width: 150 },
  { Header: 'Fecha Contable', accessor: 'DocDate', width: 150 },
  { Header: 'Cód. Socio', accessor: 'CardCode', width: 120 },
  { Header: 'Socio Negocio', accessor: 'CardName' },
  { Header: 'Importe', accessor: 'import', align: 'right', width: 120 },
  { Header: 'Impreso', accessor: 'Printed', align: 'center', width: 120 },
  { Header: 'Comentario', accessor: 'Comments', width: 250 },
  { Header: 'HR', accessor: 'prog_sheet_distribution_id', width: 75 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function PaymentRealizedSharedFile(props) {
  const classes = useStyles();

  const { title, entity, type, excelName, permission, destroyPermission } = props;

  const [paymentRealizeds, setPaymentRealizeds] = useState([]);
  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [valueSearch, setValueSearch] = useState({});
  const [bPartnerSelect, setBPartnerSelect] = useState({});

  const [pdfId, setPdfId] = useState();
  const [dataLoading, setDataLoading] = useState(false);

  async function paymentRealized(search, clear = false) {
    if (clear) delete valueSearch.base_business_partner_id; delete valueSearch.base_zone_id;
    setValueSearch({ ...valueSearch, ...search });
    const filter = { ...valueSearch, ...search };
    setDataLoading(true);
    let response = await wsFindBy(entity, filter);
    setDataLoading(false);
    if (response.success) setPaymentRealizeds(response.data);
  }

  function openPdfModal(id) {
    setPdfId(id);
  }

  async function deletePayment(id) {
    if (!window.confirm('¿Seguro de eliminar este pago?, no se puede revertir')) {
      return;
    }setDataLoading(true);
    let res = await wsRemove(entity, id);
    setDataLoading(false);
    alert(res.message);
    if (res.sucess === false) {
      return;
    }
    paymentRealized();
  }

  const pdfSrc = useMemo(() => {
    if (pdfId === undefined) return;
    return `${entity}/${pdfId}/pdf`;
  }, [pdfId]);

  useEffect(() => {
    if (bPartnerSelect.id) paymentRealized({ base_business_partner_id: bPartnerSelect.id });
  }, [bPartnerSelect]);

  return (
    <>
      {openModalBPartner ? (
        <ModalFilterBPartner
          open={openModalBPartner}
          setOpen={setOpenModalBPartner}
          cardType={type}
          entity="base/business-partner"
          setBPartnerSelect={setBPartnerSelect}
        />
      ) : undefined}

      <PdfModal open={pdfId !== undefined} onClose={() => setPdfId(undefined)} src={pdfSrc} />

      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>{title} {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <FilterCustom
            getFilter={paymentRealized}
            dateRange
            zone
            component={
              <GridItem xs={12} md={2}>
                <TextField
                  key={openModalBPartner}
                  label={type === 'C' ? 'Cliente' : 'Proveedor'}
                  type="search"
                  defaultValue={bPartnerSelect?.CardName || ''}
                  margin="normal"
                  inputProps={{ readOnly: !!bPartnerSelect.id ? false : true }}
                  required
                  onChange={(e) => {
                    if (e.target.value === '') {
                      paymentRealized(valueSearch, true);
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        style={{ cursor: 'pointer', color: '#07c107' }}
                        onClick={() => setOpenModalBPartner(true)}
                        position="start"
                      >
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
              </GridItem>
            }
          />
          <ReactTable
            excelName={excelName}
            heightRow={50}
            defaultWidth={2000}
            columns={columns}
            data={paymentRealizeds.map((item, i) => {
              return {
                num: (
                  <Box display="flex" alignItems="center">
                    {i + 1}
                    <AllowedGuard permission={permission}>
                      <Button justIcon round simple>
                        <Link to={`${item.id}`}>
                          <Visibility />
                        </Link>
                      </Button>
                      <Button
                        justIcon
                        round
                        simple
                        color="info"
                        onClick={() => openPdfModal(item.id)}
                      >
                        <PictureAsPdf />
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={destroyPermission}>
                      <Button
                        justIcon
                        round
                        simple
                        color="danger"
                        disabled={item.sapAnnuled !== null}
                        onClick={() => deletePayment(item.id)}
                      >
                        <Delete />
                      </Button>
                    </AllowedGuard>
                  </Box>
                ),
                id: item.id.toString(),
                zone: item.zone?.description || '',
                process: (
                  <>
                    {item.sapAnnuled !== null ? (
                      <Badge color={item.sapAnnuled === 'P' ? 'warning' : 'danger'}>
                        {item.sapAnnuled === 'P' ? 'Proceso anulación' : 'Anulado'}
                      </Badge>
                    ) : (
                      <>
                        {item.DocEntry !== null && <Badge color="success">Si</Badge>}
                        {item.DocEntry === null && parseInt(item.sapCount) === 0 && (
                          <Badge color="warning">Procesando</Badge>
                        )}
                        {item.DocEntry === null && parseInt(item.sapCount) > 0 && (
                          <Badge
                            color="danger"
                            style={{ cursor: 'pointer' }}
                            onClick={() => alert(item.sapError)}
                          >
                            Error!
                          </Badge>
                        )}
                      </>
                    )}
                  </>
                ),
                type:
                  item.type === 'CH'
                    ? 'Efectivo'
                    : item.type === 'TR'
                    ? 'Transferencia'
                    : item.type === 'CK'
                    ? 'Cheque'
                    : item.type === 'LT'
                    ? 'Letra'
                    : '-',
                user: item?.user?.name || '-',
                created_at: moment(item.created_at).format('DD/MM/YYYY'),
                DocDate: moment(item.DocDate).format('DD/MM/YYYY'),
                CardCode: item.CardCode,
                CardName: item.CardName,
                import:
                  item.type === 'CH'
                    ? currency(item.CashSum)
                    : item.type === 'TR'
                    ? currency(item.TrsfrSum)
                    : item.type === 'CK'
                    ? currency(item.CheckSum)
                    : item.type === 'LT'
                    ? currency(item.CheckSum)
                    : '-',
                Printed: item.Printed === 'N' ? 'No' : 'Si',
                Comments: item.Comments,
                prog_sheet_distribution_id: item.prog_sheet_distribution_id,
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
